// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// Export the factory function instead of a class to prevent initialization order problems

import type User from "le-coffre-resources/dist/Notary";
import type { QueryFilters, QueryInclude, QueryPayload, QuerySelect } from "../../../types";

// Export types
export type IGetUsersParams = {
	where?: QueryFilters;
	include?: QueryInclude;
	select?: QuerySelect;
};

export type IPutUsersParams = {
	uid?: User["uid"];
	office_role?: User["office_role"];
	role?: User["role"];
};

// Export a compatible interface for backwards compatibility
export interface IUsers {
	get(q?: IGetUsersParams): Promise<User[]>;
	getAggregated(): Promise<User[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<User>;
	getMyProfileEmails(): Promise<{ contactEmail: string | null; idnotEmail: string | null; shareInviteEmail: string | null }>;
	put(uid: string, body: IPutUsersParams): Promise<User>;
	putMyContactEmail(email: string): Promise<void>;
}

import { getLazyFactoryGetter } from "@Front/Api/helpers/dynamicFactoryLoader";

function getFactory(): () => IUsers {
	return getLazyFactoryGetter("LeCoffreApi/Notary/Users") as () => IUsers;
}

// Export the instance getter as the main export
export const Users = {
	getInstance: (): IUsers => {
		return getFactory()();
	},
};

// Export default for backward compatibility with existing imports
export default Users;
